export default "__VITE_PUBLIC_ASSET__5c94f685__"